import _ from 'underscore';

import { FlowOutputStepInfo } from '../models/FlowOutputStepInfo';
import { FlowOutputStep } from '../ServerApi/types/FlowOutputStep';
import { IDataConnection } from '../ServerApi/types/IDataConnection';
import { IDataSource } from '../ServerApi/types/IDataSource';
import { FlowRunSpecOutputStepParamsMap } from '../ServerApi/types/RunFlowTask';

type DataConnectionWithProjectId = IDataConnection & { projectId: string };

export module FlowOutputStepMapper {

  export function map(
    flowOutputSteps: ReadonlyArray<FlowOutputStep>,
    dataConnections: _.Dictionary<IDataConnection>,
    datasources: _.Dictionary<IDataSource>,
    flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap
  ): FlowOutputStepInfo[] {

    return _.map(flowOutputSteps, (fos: FlowOutputStep) => {
      const dataConnection = dataConnections[fos.connectionId];
      return {
        dataConnection: dataConnection,
        flowId: fos.flowId,
        id: fos.id,
        name: fos.name,
        datasourceName: dataConnection.datasourceId && datasources[dataConnection.datasourceId].name || '',
        datasourceId: fos.datasourceId,
        dataRoleId: fos.dataRoleId,
        isIncremental: getIsIncremental(flowRunSpecOutputStepParamsMap, fos.id),
        isIncrementalEnabled: fos.isIncrementalEnabled,
        isIncrementalDefault: fos.isIncrementalDefault,
        outputOperationType: fos.outputOperationType,
        incrementalOutputOperationType: fos.incrementalOutputOperationType
      };
    });
  }

  export function mapForRunFlowTask(
    flowOutputSteps: FlowOutputStep[],
    dataConnections: _.Dictionary<IDataConnection>,
    flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap,
    isRunAllIncremental: boolean
  ): FlowOutputStepInfo[] {

    return _.map(flowOutputSteps, (fos: FlowOutputStep) => {
      const dataConnection = dataConnections[fos.connectionId];
      return {
        dataConnection: dataConnection,
        flowId: fos.flowId,
        id: fos.id,
        name: fos.name,
        datasourceId: fos.datasourceId,
        dataRoleId: fos.dataRoleId,
        isIncremental: isRunAllIncremental != null ? isRunAllIncremental : getIsIncremental(flowRunSpecOutputStepParamsMap, fos.id),
        isIncrementalEnabled: fos.isIncrementalEnabled,
        isIncrementalDefault: fos.isIncrementalDefault,
        outputOperationType: fos.outputOperationType,
        incrementalOutputOperationType: fos.incrementalOutputOperationType
      };
    });
  }

  function getIsIncremental(flowRunSpecOutputStepParamsMap: FlowRunSpecOutputStepParamsMap, id: string) {
    if (!flowRunSpecOutputStepParamsMap){
      return null;
    }

    const param = flowRunSpecOutputStepParamsMap[parseInt(id, 10)];

    return param ? param.isIncremental : null;
  }
}
